import { FC } from "react";
import { SignIn } from "../../../../modules/authentication/components/sign-in/sign-in";

export const SignInRoute: FC = () => {
    return (
        <SignIn />
    )
}